import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(1), 0],
  },
  errorText: {
    color: theme.palette.colors.red,
    minWidth: 125,
  },
  warningText: {
    color: theme.palette.colors.amber,
    minWidth: 125,
  },
  validText: {
    color: theme.palette.colors.green,
    minWidth: 125,
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    borderRadius: 4,
    fontSize: '1.3rem',
    margin: [10, 0],
    width: '100%',
    height: 'unset',
    '& svg': { height: '1.3rem', width: '1.3rem' },
    [theme.breakpoints.up('mobile')]: {
      width: 350,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/PriceTargetQuestion/useStyles.js